import { FileNamespace } from '../../server/file-storage/types.js'
import { CommonState } from '../types.js'

export const getFileUrl = (state: CommonState, namespace: FileNamespace, key: string) => {
    return `${state.baseUrl}/files/${namespace}/${key}`
}
